{
  "common": {
    "actions": {
      "save": "सुरक्षित गर्नुहोस्",
      "edit": "सम्पादन गर्नुहोस्",
      "saveChanges": "परिवर्तनहरू सुरक्षित गर्नुहोस्",
      "saveAndExit": "सुरक्षित गरी बाहिर निस्कनुहोस्",
      "cancel": "रद्द गर्नुहोस्",
      "back": "पछाडि",
      "delete": "मेटाउनुहोस्",
      "reject": "अस्वीकार गर्नुहोस्",
      "accept": "स्वीकार गर्नुहोस्",
      "add": "थप्नुहोस्",
      "applyChanges": "परिवर्तनहरू लागू गर्नुहोस्",
      "preview": "पूर्वावलोकन",
      "close": "बन्द गर्नुहोस्",
      "revert": "फिर्ता गर्नुहोस्",
      "clickHere": "यहाँ क्लिक गर्नुहोस्",
      "continue": "जारी राख्नुहोस्",
      "export": "निर्यात गर्नुहोस्",
      "learnMore": "थप जान्नुहोस्",
      "previous": "अघिल्लो",
      "next": "अर्को",
      "complete": "पूरा गर्नुहोस्",
      "change": "परिवर्तन गर्नुहोस्"
    },
    "statuses": {
      "canceled": "रद्द गरिएको",
      "rejected": "अस्वीकृत",
      "accepted": "स्वीकार गरिएको",
      "success": "सफल",
      "failed": "असफल",
      "required": "आवश्यक",
      "open": "खुला",
      "closed": "बन्द",
      "imported": "आयात गरिएको",
      "draft": "मस्यौदा",
      "forReview": "समीक्षाका लागि",
      "forApproval": "स्वीकृतिका लागि",
      "approved": "स्वीकृत",
      "approvalDeclined": "स्वीकृति अस्वीकार गरियो",
      "effective": "प्रभावकारी",
      "superseded": "प्रतिस्थापित"
    },
    "labels": {
      "archivedRegistryItem": "{{name}} (संग्रहित)",
      "deactivatedUser": "{{name}} (निष्क्रिय पारिएको)",
      "name": "नाम",
      "type": "प्रकार",
      "email": "इमेल",
      "password": "पासवर्ड",
      "comments": "टिप्पणीहरू",
      "properties": "गुणहरू",
      "assignedTo": "तोकिएको व्यक्ति",
      "eventTitle": "घटनाको शीर्षक",
      "eventId": "घटना ID",
      "none": "कुनै पनि होइन",
      "reason": "कारण",
      "events": "घटनाहरू",
      "created": "सिर्जना गरिएको",
      "lastModified": "अन्तिम परिमार्जन",
      "steps": "चरणहरू",
      "fields": "फिल्डहरू",
      "version": "संस्करण",
      "owner": "जिम्मेवार व्यक्ति",
      "eventType": "घटनाको प्रकार",
      "eventTypes": "घटनाका प्रकारहरू",
      "taskStatus": "कार्यको स्थिति",
      "createdBetween": "बीचमा सिर्जना गरिएको",
      "due": "म्याद",
      "status": "स्थिति",
      "owners": "जिम्मेवार व्यक्तिहरू",
      "startDate": "सुरु मिति",
      "endDate": "अन्त्य मिति",
      "risk": "जोखिम",
      "severity": "गम्भीरता",
      "ownerEmail": "जिम्मेवार व्यक्तिको इमेल",
      "probability": "सम्भाव्यता",
      "product": "उत्पादन",
      "products": "उत्पादनहरू",
      "rootCause": "मूल कारण",
      "rootCauses": "मूल कारणहरू",
      "relatedRecords": "सम्बन्धहरू",
      "source": "स्रोत",
      "assignee": "तोकिएको व्यक्ति",
      "description": "विवरण",
      "visible": "देखिने",
      "required": "आवश्यक",
      "title": "शीर्षक",
      "prefix": "उपसर्ग",
      "attachments": "संलग्नकहरू",
      "resolution": "समाधान",
      "relatedTo": "सम्बन्धित",
      "approvers": "स्वीकृतकर्ताहरू",
      "reviewers": "समीक्षकहरू",
      "total": "जम्मा",
      "approvalDate": "स्वीकृति मिति",
      "id": "ID",
      "tags": "ट्यागहरू",
      "emptyProducts": "खाली उत्पादनहरू",
      "emptyRootCauses": "खाली मूल कारणहरू",
      "emptyTags": "खाली ट्यागहरू",
      "emptySeverities": "खाली गम्भीरताहरू",
      "emptyProbabilities": "खाली सम्भाव्यताहरू",
      "suppliers": "आपूर्तिकर्ताहरू",
      "dueDate": "अन्तिम मिति",
      "currentDueDate": "हालको अन्तिम मिति",
      "newDueDate": "नयाँ अन्तिम मिति",
      "selectANewOwner": "नयाँ जिम्मेवार व्यक्ति चयन गर्नुहोस्",
      "tasks": "कार्यहरू",
      "usersList": "प्रयोगकर्ता सूची",
      "createdBefore": "यसअघि सिर्जना गरिएको",
      "createdAfter": "यसपछि सिर्जना गरिएको",
      "dueAfter": "यसपछि म्याद",
      "dueBefore": "यसअघि म्याद",
      "resolvedAfter": "यसपछि समाधान गरिएको",
      "resolvedBefore": "यसअघि समाधान गरिएको",
      "overdue": "म्याद नाघेको",
      "onTime": "समयमै",
      "integrationVariables": "एकीकरण चरहरू",
      "comment": "टिप्पणी",
      "currentOwner": "हालको जिम्मेवार व्यक्ति",
      "newOwner": "नयाँ जिम्मेवार व्यक्ति",
      "defaultSections": "पूर्वनिर्धारित खण्डहरू",
      "formSteps": "फारम चरणहरू",
      "capturedIn": "यसमा सङ्कलन गरिएको",
      "inSection": "खण्डमा",
      "open": "खुला",
      "canceled": "रद्द गरिएको",
      "completed": "पूरा भएको",
      "templateOwner": "टेम्प्लेटको जिम्मेवार व्यक्ति",
      "timeLimitDays": "समय सीमा (दिन)",
      "validationStepTimeDelayDays": "प्रमाणीकरण चरणको समय ढिलाइ (दिन)",
      "newTemplateOwner": "टेम्प्लेटको नयाँ जिम्मेवार व्यक्ति",
      "defaultContent": "पूर्वनिर्धारित सामग्री",
      "sectionWithPosition": "खण्ड {{position}}",
      "back": "पछाडि",
      "moveUp": "माथि सार्नुहोस्",
      "moveDown": "तल सार्नुहोस्",
      "yes": "हो",
      "no": "होइन",
      "view": "हेर्नुहोस्",
      "resolved": "समाधान गरिएको",
      "closed": "बन्द",
      "imported": "आयात गरिएको",
      "manage": "व्यवस्थापन गर्नुहोस्",
      "emptyState": "--",
      "order": "क्रम",
      "fullName": "पूरा नाम",
      "groups": "समूहहरू",
      "taskName": "कार्यको नाम",
      "approve": "स्वीकृत गर्नुहोस्",
      "decline": "अस्वीकार गर्नुहोस्",
      "revert": "फिर्ता गर्नुहोस्",
      "eventClosed": "घटना बन्द गरियो",
      "stepCompleted": "चरण पूरा भयो",
      "stepReverted": "चरण फिर्ता गरियो",
      "eventReopened": "घटना पुनः खोलियो",
      "reviewersAssigned": "समीक्षकहरू तोकिए!",
      "approversAssigned": "स्वीकृतकर्ताहरू तोकिए!",
      "and": "र",
      "content": "सामग्री",
      "form": "फारम",
      "validationWithType": "प्रमाणीकरण ({{type}})",
      "reopen": "पुनः खोल्नुहोस्",
      "qualityApproverRequired": "गुणस्तर स्वीकृतकर्ता आवश्यक छ"
    },
    "placeholders": {
      "email": "इमेल...",
      "password": "पासवर्ड...",
      "enterANumber": "संख्या प्रविष्ट गर्नुहोस्",
      "writeAComment": "टिप्पणी लेख्नुहोस्...",
      "searchFor": "थप्नका लागि {{domain}} खोज्नुहोस्...",
      "noResults": "कुनै नतिजा छैन",
      "startTypingToSearchFor": "खोज्न टाइप गर्न सुरु गर्नुहोस्:",
      "newestFirst": "नयाँ पहिले",
      "oldestFirst": "पुरानो पहिले"
    },
    "errors": {
      "defaultErrorMessage": "सर्भरसँग सञ्चार गर्दा समस्या भयो।",
      "timeZoneMissingMessage": "प्रयोगकर्ताको समय क्षेत्र भेटिएन",
      "invalidCredentials": "अमान्य प्रमाणपत्रहरू",
      "somethingHasGoneWrong": "केही गलत भयो!",
      "currentCompanyRoleError": "हालको इन्स्ट्यान्समा प्रयोगकर्ताको भूमिका निर्धारण गर्न सकिएन",
      "failedToFetchEventDetails": "घटनाको विवरण ल्याउन असफल भयो",
      "duplicateTitlesNotAllowed": "दोहोरिएका शीर्षकहरू अनुमति छैन। कृपया अद्वितीय शीर्षकहरू प्रयोग गर्नुहोस्।",
      "invalidCharactersInTitle": "शीर्षकमा अमान्य अक्षर(हरू): {{characters}}",
      "missingRequiredFieldsClickHere": "घटनामा केही आवश्यक फिल्डहरू छुटेका छन्। आवश्यक घटना फिल्डहरू हेर्न यहाँ क्लिक गर्नुहोस्।",
      "missingRequiredFieldsWithPrefix": "...घटनामा। आवश्यक घटना फिल्डहरू हेर्न यहाँ क्लिक गर्नुहोस्।",
      "invalidCharactersInTitlePrefix": "शीर्षकमा अमान्य अक्षर(हरू):"
    },
    "notifications": {
      "fileReady": "फाइल तयार छ",
      "preparingFileForDownload": "डाउनलोडका लागि फाइल तयार गरिँदैछ",
      "error": "त्रुटि",
      "userReassigned": "प्रयोगकर्ता पुनः तोकियो",
      "eventCreated": "घटना सिर्जना गरियो",
      "missingInformation": "जानकारी छुटेको छ",
      "success": "सफल",
      "draftDeleted": "मस्यौदा मेटाइयो",
      "draftNotDeleted": "मस्यौदा मेटाइएन",
      "ownerChanged": "जिम्मेवार व्यक्ति परिवर्तन गरियो",
      "ownerNotChanged": "जिम्मेवार व्यक्ति परिवर्तन गरिएन",
      "eventOpened": "घटना खोलियो",
      "eventNotOpened": "घटना खोलिएन",
      "eventUpdated": "घटना अद्यावधिक गरियो",
      "eventNotUpdated": "घटना अद्यावधिक गरिएन",
      "taskCompleted": "कार्य पूरा भयो",
      "taskNotCompleted": "कार्य पूरा भएन",
      "failed": "असफल",
      "tagsUpdated": "ट्यागहरू अद्यावधिक गरिए",
      "tagsNotUpdated": "ट्यागहरू अद्यावधिक गरिएनन्",
      "eventPropertiesUpdated": "घटनाका गुणहरू अद्यावधिक गरिए",
      "newEventCreated": "नयाँ घटना सिर्जना गरियो",
      "eventNotCreated": "घटना सिर्जना गरिएन",
      "couldNotRetrieveEventMetadata": "घटनाको मेटाडाटा प्राप्त गर्न सकिएन",
      "couldNotRetrieveGroups": "समूहहरू प्राप्त गर्न सकिएन",
      "failedToFetchEventTemplateDetails": "घटना टेम्प्लेटको विवरण ल्याउन असफल भयो",
      "eventUpdateFailed": "घटना अद्यावधिक गर्न असफल भयो",
      "revertedToDraft": "मस्यौदामा फिर्ता गरियो",
      "changesSaved": "परिवर्तनहरू सुरक्षित गरिए",
      "failedToUpdateTask": "कार्य अद्यावधिक गर्न असफल भयो",
      "couldNotRetrieveTags": "ट्यागहरू प्राप्त गर्न सकिएन",
      "couldNotRetrieveUsers": "प्रयोगकर्ताहरू प्राप्त गर्न सकिएन",
      "reviewed": "समीक्षा गरियो",
      "stepNotReviewed": "चरणको समीक्षा गरिएन",
      "eventReassignmentFailed": "घटना पुनः तोक्न असफल भयो",
      "couldNotRetrieveEventTypes": "घटनाका प्रकारहरू प्राप्त गर्न सकिएन",
      "failedToFetchFormTemplateDetails": "फारम टेम्प्लेटको विवरण ल्याउन असफल भयो",
      "formTemplateUpdateFailed": "फारम टेम्प्लेट अद्यावधिक गर्न असफल भयो",
      "eventTemplateUpdated": "घटना टेम्प्लेट अद्यावधिक गरियो",
      "eventTemplateNotUpdated": "घटना टेम्प्लेट अद्यावधिक गरिएन",
      "newDraftCreated": "नयाँ मस्यौदा सिर्जना गरियो",
      "creatingNewDraftFailed": "नयाँ मस्यौदा सिर्जना गर्न असफल भयो",
      "templateArchived": "टेम्प्लेट संग्रहित गरियो",
      "templateArchivingFailed": "टेम्प्लेट संग्रहित गर्न असफल भयो",
      "templateRestored": "टेम्प्लेट पुनर्स्थापित गरियो",
      "templateRestoringFailed": "टेम्प्लेट पुनर्स्थापित गर्न असफल भयो",
      "missingRequiredFields": "आवश्यक फिल्डहरू छुटेका छन्",
      "temporarilyUnableToRetrieveAllEventProperties": "अस्थायी रूपमा घटनाका सबै गुणहरू प्राप्त गर्न सकिएन",
      "reviewRequest": "समीक्षा अनुरोध",
      "yourReviewIsRequired": "तपाईंको समीक्षा आवश्यक छ",
      "fileReadyToDownloadPrefix": "फाइल अब उपलब्ध छ:",
      "fileReadyToDownloadLinkText": "डाउनलोड गर्नुहोस्",
      "couldNotRetrieveSummaryFromAI": "AI सेवाबाट सारांश प्राप्त गर्न सकिएन",
      "propertiesUpdateForEvent": "घटना {{eventCode}} का गुणहरू सफलतापूर्वक अद्यावधिक गरिए",
      "eventCreatedDesc": "\"{{eventCode}} | {{eventTitle}}\" सिर्जना गरियो",
      "eventCreatedWithTitle": "\"{{title}}\" सिर्जना गरियो",
      "tagsUpdatedDesc": "{{eventCode}} का ट्यागहरू सफलतापूर्वक अद्यावधिक गरिए",
      "eventUpdatedToLatestTemplate": "घटनालाई नवीनतम घटना टेम्प्लेटमा अद्यावधिक गरिएको छ।",
      "eventNotUpdatedToLatestTemplate": "घटनालाई नवीनतम घटना टेम्प्लेटमा अद्यावधिक गरिएको छैन।",
      "draftSuccessfullyDeleted": "मस्यौदा सफलतापूर्वक मेटाइयो",
      "failedToDeleteTheDraft": "मस्यौदा मेटाउन असफल भयो",
      "pleaseSaveTheEventTemplateFirst": "कृपया पहिले घटना टेम्प्लेट सुरक्षित गर्नुहोस्",
      "wellLetYouKnowWhenFileIsReady": "फाइल तयार भएपछि हामी तपाईंलाई जानकारी दिनेछौं",
      "exportingEventCodeTitle": "{{code}} {{title}} निर्यात गरिँदैछ",
      "ownerSuccessfullyChanged": "{{eventCode}} को जिम्मेवार व्यक्ति सफलतापूर्वक परिवर्तन गरियो",
      "theTeamHasBeenNotified": "टोलीलाई जानकारी दिइएको छ। कृपया रिफ्रेस गर्नुहोस् वा पछि फेरि प्रयास गर्नुहोस्।"
    },
    "filters": {
      "filterByOwner": "जिम्मेवार व्यक्तिअनुसार फिल्टर गर्नुहोस्...",
      "filterByCollaborator": "सहकर्मीअनुसार फिल्टर गर्नुहोस्...",
      "filterByAssignee": "तोकिएको व्यक्तिअनुसार फिल्टर गर्नुहोस्...",
      "filterByCreatedDate": "सिर्जना मितिअनुसार फिल्टर गर्नुहोस्...",
      "filterByDueDate": "अन्तिम मितिअनुसार फिल्टर गर्नुहोस्...",
      "filterByResolvedDate": "समाधान मितिअनुसार फिल्टर गर्नुहोस्...",
      "filterByDueStatus": "म्यादको स्थितिअनुसार फिल्टर गर्नुहोस्...",
      "filterByProduct": "उत्पादनअनुसार फिल्टर गर्नुहोस्...",
      "filterByRootCause": "मूल कारणअनुसार फिल्टर गर्नुहोस्...",
      "filterByTags": "ट्यागहरूअनुसार फिल्टर गर्नुहोस्...",
      "filterByProbability": "सम्भाव्यताअनुसार फिल्टर गर्नुहोस्...",
      "filterByNameEmailOrGroupName": "नाम, इमेल वा समूहको नामअनुसार फिल्टर गर्नुहोस्...",
      "filterBySeverity": "गम्भीरताअनुसार फिल्टर गर्नुहोस्...",
      "searchRelatedRecords": "सम्बन्धहरूअनुसार फिल्टर गर्नुहोस्...",
      "searchMore": "थप खोज्नुहोस्...",
      "filterByStatus": "स्थितिअनुसार फिल्टर गर्नुहोस्...",
      "filterByEventType": "घटनाको प्रकारअनुसार फिल्टर गर्नुहोस्...",
      "approversAdded": "स्वीकृतकर्ताहरू थपिए",
      "approversRemoved": "स्वीकृतकर्ताहरू हटाइए",
      "reviewersAdded": "समीक्षकहरू थपिए",
      "reviewersRemoved": "समीक्षकहरू हटाइए",
      "reasonForRemovingTheUserType": "{{userType}} हटाउनुको कारण..."
    },
    "tables": {
      "noMatchingEventsFound": "मिल्दो कुनै घटना भेटिएन",
      "noMatchingTasksFound": "मिल्दो कुनै कार्य भेटिएन"
    },
    "pagination": {
      "show": "देखाउनुहोस्",
      "showSpace": "देखाउनुहोस् ",
      "previousPage": "अघिल्लो पृष्ठ",
      "nextPage": "अर्को पृष्ठ"
    },
    "exports": {
      "fileReady": "फाइल तयार छ",
      "preparingFileForDownload": "डाउनलोडका लागि फाइल तयार गरिँदैछ",
      "failedToExportTheFile": "फाइल निर्यात गर्न असफल भयो।",
      "xlsx": "XLSX",
      "pdf": "PDF"
    },
    "units": {
      "days": "दिन"
    },
    "debug": {
      "noFlagsReturnedInThisEnvironment": "यस वातावरणमा कुनै फ्ल्याग फर्काइएन",
      "knownFlags": "ज्ञात फ्ल्यागहरू",
      "rawLDFlagValues": "LD फ्ल्यागका कच्चा मानहरू"
    }
  },
  "templates": {
    "labels": {
      "eventTemplates": "घटना टेम्प्लेटहरू",
      "templateStatus": "टेम्प्लेटको स्थिति",
      "templateOwner": "टेम्प्लेटको जिम्मेवार व्यक्ति",
      "defaultAssignee": "पूर्वनिर्धारित तोकिएको व्यक्ति",
      "defaultEventOwner": "पूर्वनिर्धारित घटना जिम्मेवार व्यक्ति",
      "defaultTimeLimit": "पूर्वनिर्धारित समय सीमा",
      "validationStepTimeDelay": "प्रमाणीकरण चरणको समय ढिलाइ",
      "timeLimitDays": "समय सीमा (दिन)",
      "validationStepTimeDelayDays": "प्रमाणीकरण चरणको समय ढिलाइ (दिन)",
      "defaultSections": "पूर्वनिर्धारित खण्डहरू",
      "formSteps": "फारम चरणहरू",
      "inSection": "खण्डमा"
    },
    "steps": {
      "dueDays": {
        "header": "म्याद दिनहरू",
        "tooltip": "यस टेम्प्लेटबाट घटना सिर्जना भएपछि यो चरणको म्याद पुग्न लाग्ने दिनहरूको संख्या। गणना घटना सिर्जना भएको समयदेखि सुरु हुन्छ।",
        "validation": {
          "range": "0 देखि 100000 सम्मको पूर्ण संख्यामा दिनहरू प्रविष्ट गर्नुहोस्।"
        }
      }
    },
    "actions": {
      "editEventTemplate": "घटना टेम्प्लेट सम्पादन गर्नुहोस्",
      "createTemplateDraft": "टेम्प्लेट मस्यौदा सिर्जना गर्नुहोस्",
      "makeEffective": "प्रभावकारी बनाउनुहोस्",
      "addStep": "चरण थप्नुहोस्",
      "deleteDraft": "मस्यौदा मेटाउनुहोस्",
      "changeTemplateOwner": "टेम्प्लेटको जिम्मेवार व्यक्ति परिवर्तन गर्नुहोस्",
      "createEventTemplate": "घटना टेम्प्लेट सिर्जना गर्नुहोस्",
      "renameStep": "चरणको नाम बदल्नुहोस्",
      "changeValidationStepType": "प्रमाणीकरण चरणको प्रकार परिवर्तन गर्नुहोस्",
      "selectResolution": "समाधान चयन गर्नुहोस्",
      "updateTemplate": "टेम्प्लेट अद्यावधिक गर्नुहोस्",
      "deleteStep": "चरण मेटाउनुहोस्",
      "createTemplate": "टेम्प्लेट सिर्जना गर्नुहोस्",
      "addSection": "खण्ड थप्नुहोस्",
      "editContentTemplate": "सामग्री टेम्प्लेट सम्पादन गर्नुहोस्"
    },
    "statuses": {
      "draft": "मस्यौदा",
      "effective": "प्रभावकारी",
      "archived": "संग्रहित",
      "forApproval": "स्वीकृतिका लागि",
      "approvalDeclined": "स्वीकृति अस्वीकार गरियो",
      "superseded": "प्रतिस्थापित",
      "allActiveStatuses": "सबै खुला स्थितिहरू"
    },
    "messages": {
      "eventTemplateCreated": "घटना टेम्प्लेट सिर्जना गरियो",
      "templateCreatedWithTitle": "\"{{title}}\" सिर्जना गरियो",
      "eventTemplateCreatedFailTitle": "घटना टेम्प्लेट सिर्जना गरिएन",
      "makeEffectiveSuccessMessage": "घटना टेम्प्लेटलाई प्रभावकारी बनाइयो",
      "eventTemplateUpdateFailTitle": "घटना टेम्प्लेट अद्यावधिक गरिएन",
      "changeEventTemplateOwnerSuccessMessage": "टेम्प्लेटको जिम्मेवार व्यक्ति अद्यावधिक गरियो",
      "duplicatedStepNames": "चरणका नामहरू दोहोरिएका छन्!",
      "updatesHaveBeenMadeToThisTemplate": "यो टेम्प्लेटमा अद्यावधिकहरू गरिएका छन्",
      "pleaseChooseAResolution": "कृपया तलका टेम्प्लेट परिवर्तनहरूको लागि समाधान छान्नुहोस्। यस समयमा कागजातमा कुनै परिवर्तन लागू गरिने छैन।",
      "aPrefixWillBeAutomaticallyAdded": "सिर्जना गरिने प्रत्येक घटनामा स्वचालित रूपमा उपसर्ग थपिनेछ।",
      "eachEventMustBeResolved": "प्रत्येक घटना तोकिएको दिनभित्र समाधान गर्नुपर्छ। यो पूर्वनिर्धारित मान हो र घटना सिर्जना गर्दा परिवर्तन गर्न सकिन्छ।",
      "determinesHowManyDays": "अन्तिम चरणको स्वीकृति पूरा गर्न सक्नुअघि कति दिन बित्नुपर्छ भन्ने निर्धारण गर्छ।",
      "templateSuccessfullyUpdated": "टेम्प्लेट सफलतापूर्वक अद्यावधिक गरियो",
      "failedToUpdateTheTemplate": "टेम्प्लेट अद्यावधिक गर्न असफल भयो:",
      "makeThisAResolutionSection": "यसलाई समाधान खण्ड बनाउनुहोस्",
      "contentTemplateNotCreated": "सामग्री टेम्प्लेट सिर्जना गरिएन",
      "formTemplateNotCreated": "फारम टेम्प्लेट सिर्जना गरिएन",
      "editContentTemplate": "सामग्री टेम्प्लेट सम्पादन गर्नुहोस्",
      "editFormTemplate": "फारम टेम्प्लेट सम्पादन गर्नुहोस्",
      "startBuildingYourForm": "आफ्नो फारम बनाउन सुरु गर्नुहोस्",
      "makeThisTheValidationStep": "यसलाई प्रमाणीकरण चरण बनाउनुहोस्",
      "onlyOneResolutionSectionAllowed": "\"समाधान\" प्रकारको एउटा मात्र खण्ड अनुमति छ। कृपया पहिले अर्को खण्डको प्रकार परिवर्तन गर्नुहोस्।",
      "resolutionSectionDescription": "\"समाधान\" प्रकारको खण्डलाई समस्या ठीकसँग समाधान भयो वा भएन भनी पुष्टि गर्न सम्पादनयोग्य चेकबक्सका रूपमा देखाइनेछ।",
      "optionalQualityApproverHelper": "गुणस्तर स्वीकृतकर्ता वैकल्पिक भएका चरणहरूका लागि कम्तीमा एक अन्य स्वीकृतकर्ता आवश्यक छ।"
    },
    "modals": {
      "makeEffectiveModalHeadingText": "टेम्प्लेटलाई प्रभावकारी बनाउनुहोस्",
      "makeEffectiveModalSubText": "यो टेम्प्लेटलाई प्रभावकारी बनाउन आफ्नो डिजिटल हस्ताक्षर प्रविष्ट गर्नुहोस्।",
      "deleteDraftConfirmationHeader": "मस्यौदा मेटाउने?",
      "deleteDraftConformationBody": "के तपाईं यो मस्यौदा मेटाउन निश्चित हुनुहुन्छ? तपाईंका परिवर्तनहरू सुरक्षित हुने छैनन्।",
      "exportModalTitle": "घटना टेम्प्लेट निर्यात गर्नुहोस्",
      "exportModalSubText": "Qualio ले घटना टेम्प्लेटहरू PDF का रूपमा निर्यात गर्छ।",
      "exportCoverPageTitle": "आवरण पृष्ठ",
      "exportCoverPageSubText": "आवरण पृष्ठमा टेम्प्लेट निर्यातको पहिलो पृष्ठका रूपमा घटना टेम्प्लेटका गुणहरू समावेश हुन्छन्।",
      "exportIncludeCoverPage": "आवरण पृष्ठ समावेश गर्नुहोस्"
    },
    "fields": {
      "currentEventTemplateOwnerLabel": "हालको",
      "reasonForChangeInputLabel": "परिवर्तनको कारण",
      "reasonForChangePlaceholder": "यो टेम्प्लेटलाई प्रभावकारी बनाउनुको कारण थप्नुहोस्..."
    },
    "helpText": {
      "templateFieldControlDescription": "यस प्रकारको घटनाका लागि प्रयोगकर्ताहरूले सङ्कलन गर्नुपर्ने फिल्डहरू देखाउनुहोस्, वा सान्दर्भिक नभएमा लुकाउनुहोस्। फिल्ड आवश्यक हो वा होइन भनी पनि चयन गर्न सक्नुहुन्छ। घटना बन्द गर्दा आवश्यक फिल्डहरू पूरा भएको जाँच गरिनेछ।",
      "templateFieldControlDescriptionForEventCapture": "यस प्रकारको घटनाका लागि प्रयोगकर्ताहरूले सङ्कलन गर्नुपर्ने फिल्डहरू देखाउनुहोस्, वा सान्दर्भिक नभएमा लुकाउनुहोस्। फिल्ड सङ्कलन गर्ने फारम चरण तोक्न सक्नुहुन्छ (पूर्वनिर्धारित रूपमा घटनाका गुणहरू)। फिल्ड आवश्यक हो वा होइन भनी पनि चयन गर्न सक्नुहुन्छ। घटना बन्द गर्दा आवश्यक फिल्डहरू पूरा भएको जाँच गरिनेछ।",
      "defaultAssigneeHelper": "घटना सिर्जना हुँदा जिम्मेवार व्यक्ति स्वचालित रूपमा तोकिनेछ र जुनसुकै बेला परिवर्तन गर्न सकिन्छ। एकीकरणमार्फत स्वचालित रूपमा घटनाहरू सिर्जना गर्न पूर्वनिर्धारित तोकिएको व्यक्ति तोकिएको हुनुपर्छ।",
      "defaultEventOwnerHelper": "घटना सिर्जना हुँदा जिम्मेवार व्यक्ति स्वचालित रूपमा तोकिनेछ र जुनसुकै बेला परिवर्तन गर्न सकिन्छ। एकीकरणमार्फत स्वचालित रूपमा घटनाहरू सिर्जना गर्न पूर्वनिर्धारित घटना जिम्मेवार व्यक्ति तोकिएको हुनुपर्छ।",
      "prefixHelpText": "यो टेम्प्लेट प्रयोग गरी सिर्जना गरिने प्रत्येक घटनामा स्वचालित रूपमा उपसर्ग थपिनेछ। उपसर्गमा अक्षर र अङ्क मात्र हुन सक्छन्।",
      "defaultTimeLimitDefaultHelpText": "प्रत्येक घटना तोकिएको दिनभित्र समाधान गर्नुपर्छ। यो पूर्वनिर्धारित मान हो, र घटना सिर्जना गर्दा परिवर्तन गर्न सकिन्छ।",
      "defaultTimeLimitEventDueDateHelpText": "प्रत्येक घटना तोकिएको दिनभित्र समाधान गर्नुपर्छ। घटनाका प्रारम्भिक अन्तिम मितिहरू यही मानका आधारमा गणना गरिनेछन्।",
      "validationStepTimeDelayHelpText": "अन्तिम चरणको स्वीकृति पूरा गर्न सक्नुअघि कति दिन बित्नुपर्छ भन्ने निर्धारण गर्छ।"
    },
    "validation": {
      "emptyTitlesAreNotAllowed": "खाली शीर्षकहरू अनुमति छैन",
      "duplicateTitlesAreNotAllowed": "दोहोरिएका शीर्षकहरू अनुमति छैन"
    },
    "ckeditor": {
      "insertCodeBlock": "कोड ब्लक घुसाउनुहोस्",
      "insertCodeBlockCaps": "कोड ब्लक घुसाउनुहोस्",
      "paragraph": "अनुच्छेद",
      "heading1": "शीर्षक 1",
      "heading2": "शीर्षक 2",
      "heading3": "शीर्षक 3",
      "heading4": "शीर्षक 4",
      "normal": "सामान्य"
    },
    "content": {
      "resolveSection": "खण्ड '{{sectionTitle}}' हटाउन चिन्ह लगाइएको छ, कृपया समाधान चयन गर्नुहोस्"
    }
  },
  "forms": {
    "labels": {
      "fieldTitle": "फिल्डको शीर्षक",
      "helpText": "सहायता पाठ",
      "sectionFieldTitle": "खण्डको शीर्षक",
      "sectionDescription": "खण्डको विवरण",
      "defaultContent": "पूर्वनिर्धारित सामग्री",
      "multiSelect": "बहु-चयन",
      "optionSectionLabel": "विकल्पहरू",
      "reviewStep": "समीक्षा चरण"
    },
    "actions": {
      "completeForm": "फारम पूरा गर्नुहोस्",
      "addField": "फिल्ड थप्नुहोस्",
      "addFormElement": "फारम तत्व थप्नुहोस्",
      "createNewField": "नयाँ फिल्ड सिर्जना गर्नुहोस्",
      "chooseQualioResource": "Qualio स्रोत छान्नुहोस्",
      "addHelpText": "सहायता पाठ थप्नुहोस्",
      "editHelpText": "सहायता पाठ सम्पादन गर्नुहोस्",
      "addSectionDescription": "खण्डको विवरण थप्नुहोस्",
      "editSectionDescription": "खण्डको विवरण सम्पादन गर्नुहोस्",
      "addDefaultContent": "पूर्वनिर्धारित सामग्री थप्नुहोस्",
      "editDefaultContent": "पूर्वनिर्धारित सामग्री सम्पादन गर्नुहोस्",
      "addOption": "विकल्प थप्नुहोस्",
      "startBuildingForm": "आफ्नो फारम बनाउन सुरु गर्नुहोस्",
      "editForm": "फारम सम्पादन गर्नुहोस्",
      "sendForReview": "समीक्षाका लागि पठाउनुहोस्",
      "sendForApproval": "स्वीकृतिका लागि पठाउनुहोस्",
      "reassignStep": "चरण पुनः तोक्नुहोस्",
      "manageReviewers": "समीक्षकहरू व्यवस्थापन गर्नुहोस्",
      "manageApprovers": "स्वीकृतकर्ताहरू व्यवस्थापन गर्नुहोस्",
      "revertToDraft": "मस्यौदामा फिर्ता गर्नुहोस्",
      "markAsReviewed": "समीक्षा गरिएको भनी चिन्ह लगाउनुहोस्",
      "reassignStepAction": "चरण पुनः तोक्नुहोस्"
    },
    "messages": {
      "noFormElementAddedYet": "अहिलेसम्म कुनै फारम तत्व थपिएको छैन",
      "addFormElementToStartBuilding": "आफ्नो फारम बनाउन सुरु गर्न फारम तत्व थप्नुहोस्",
      "formUpdateSuccessTitle": "फारमका मानहरू अद्यावधिक गरिए",
      "formUpdateSuccessMessage": "फारम सफलतापूर्वक अद्यावधिक गरियो",
      "formUpdateFailedTitle": "फारम अद्यावधिक गरिएन",
      "formMissingMessage": "फारम भेटिएन",
      "formPreviewWarning": "तपाईं फारमको पूर्वावलोकन गर्दै हुनुहुन्छ",
      "formPreviewDuplicateLabelWarning": "एक वा बढी फिल्डहरूका लेबलहरू दोहोरिएका छन्। आवश्यकताअनुसार मिलाउन फारम सम्पादन गर्नुहोस्।",
      "noFormYet": "पूर्वावलोकन गर्न अहिलेसम्म कुनै फारम छैन",
      "startFormCopy": "आफ्नो फारम बनाउन सुरु गरौं। फारमहरूमार्फत तपाईं घटनासम्बन्धी विशिष्ट जानकारी सङ्कलन गर्न र पछि आफ्ना निष्कर्षहरूको विश्लेषण र प्रतिवेदन गर्न सक्नुहुन्छ।",
      "approversUpdateSuccessTitle": "{{approverType}} अद्यावधिक गरियो",
      "approversUpdateSuccessMessage": "यस फारमका {{approverType}} सफलतापूर्वक अद्यावधिक गरियो",
      "approversUpdateFailedTitle": "{{approverType}} अद्यावधिक गर्न असफल भयो",
      "approversUpdateFailedMessage": "एक वा बढी {{approverType}} अद्यावधिक गरिएन, कृपया आफ्ना {{approverType}} समीक्षा गर्नुहोस्",
      "atLeastOneAssigneeRequiredMessage": "\"{{status}}\" स्थितिमा रहेको फारमका लागि कम्तीमा एक तोकिएको व्यक्ति आवश्यक छ",
      "removingActionedApproverErrorMessage": "कारबाही गरिसकेका {{approverType}} हटाउन सकिँदैन",
      "reviewForm": "\"{{formName}}\" समीक्षा गर्नुहोस्",
      "disabledDeleteTooltip": "{{fieldType}} फिल्डको दृश्यता टेम्प्लेटमा सेट गरिएको छ। यो फिल्डलाई चरणबाट स्वचालित रूपमा हटाउन दृश्यता बन्द गर्नुहोस्।",
      "disableRequiredTooltip": "{{fieldType}} फिल्डको अनिवार्य सेटिङ टेम्प्लेटमा उपलब्ध छ। यसलाई व्यवस्थापन गर्न टेम्प्लेट फिल्डहरूमा \"आवश्यक\" स्विच टगल गर्नुहोस्।",
      "pleaseMarkThisStepAsReviewed": "कृपया यो चरणलाई समीक्षा गरिएको भनी चिन्ह लगाउनुहोस्",
      "reviewersAdded": "समीक्षकहरू थपिए"
    },
    "fieldTypes": {
      "text": "एक लाइन पाठ",
      "richText": "रिच टेक्स्ट अनुच्छेद",
      "date": "मिति",
      "dropdown": "ड्रपडाउन",
      "boolean": "हो / होइन",
      "numeric": "संख्यात्मक",
      "attachment": "संलग्नक",
      "document": "कागजात",
      "event": "घटना",
      "supplier": "आपूर्तिकर्ता",
      "user": "प्रयोगकर्ता",
      "section": "खण्ड",
      "checkbox": "चेकबक्सहरू",
      "radio": "रेडियो बटनहरू",
      "changeRequest": "परिवर्तन अनुरोध",
      "registry": "रजिस्ट्री",
      "designControls": "डिजाइन नियन्त्रणहरू",
      "training": "तालिम",
      "documentTemplates": "टेम्प्लेटहरू",
      "eventTemplates": "घटना टेम्प्लेटहरू",
      "task": "कार्य"
    },
    "validation": {
      "optionValueRequired": "विकल्पको मान आवश्यक छ",
      "optionValueTooLarge": "विकल्पको मान 512 अक्षरभन्दा कम हुनुपर्छ",
      "optionValueUnique": "विकल्पहरूका नामहरू दोहोरिन सक्दैनन्",
      "requiredFieldHelper": "बन्द घटनाहरूका लागि यो फिल्ड आवश्यक छ",
      "formContentInvalidError": "फारमको सामग्री मान्य छैन",
      "required": "आवश्यक"
    },
    "statusChanges": {
      "sentForReview": "समीक्षाका लागि पठाइयो",
      "sentForApproval": "स्वीकृतिका लागि पठाइयो",
      "revertedToDraft": "मस्यौदामा फिर्ता गरियो",
      "cannotSendForReview": "समीक्षाका लागि पठाउन सकिँदैन",
      "cannotSendForApproval": "स्वीकृतिका लागि पठाउन सकिँदैन",
      "cannotRevertToDraft": "मस्यौदामा फिर्ता गर्न सकिँदैन",
      "cannotUpdateTheForm": "फारम अद्यावधिक गर्न सकिँदैन",
      "wasSentForReview": "{{formTitle}} समीक्षाका लागि पठाइयो",
      "wasSentForApproval": "{{formTitle}} स्वीकृतिका लागि पठाइयो",
      "wasRevertedToDraft": "मस्यौदामा फिर्ता गरियो"
    },
    "approvers": {
      "reviewers": "समीक्षकहरू",
      "qualityApprovers": "गुणस्तर स्वीकृतकर्ताहरू",
      "otherApprovers": "अन्य स्वीकृतकर्ताहरू",
      "approverDeclinedStepOnDate": "{{approverName}} ले {{date}} मा निम्न टिप्पणीसहित यो चरण अस्वीकार गर्नुभयो:"
    },
    "errors": {
      "cannotSendForApprovalMissingRequiredFields": "घटनामा आवश्यक फिल्डहरू छुटेकाले स्वीकृतिका लागि पठाउन सकिँदैन",
      "pleaseAddApproversBeforeSubmitting": "कृपया स्वीकृतिका लागि पेस गर्नुअघि स्वीकृतकर्ताहरू थप्नुहोस्। साथै, घटनामा केही आवश्यक फिल्डहरू छुटेका छन्।",
      "missingRequiredFieldsOnEvent": "घटनामा केही आवश्यक फिल्डहरू छुटेका छन्।",
      "toViewTheRequiredEventFields": "आवश्यक घटना फिल्डहरू हेर्नका लागि।"
    }
  },
  "events": {
    "labels": {
      "eventProperties": "घटनाका गुणहरू",
      "relatedEvents": "सम्बन्धित घटनाहरू",
      "relatedDocuments": "सम्बन्धित कागजातहरू",
      "sourceEvent": "स्रोत घटना",
      "escalatedTo": "यसमा उच्च तहमा पठाइएको",
      "relatedSuppliers": "सम्बन्धित आपूर्तिकर्ताहरू",
      "events": "घटनाहरू",
      "tasks": "कार्यहरू",
      "products": "उत्पादनहरू",
      "collaborators": "सहकर्मीहरू"
    },
    "actions": {
      "createEvent": "घटना सिर्जना गर्नुहोस्",
      "editEvent": "घटना सम्पादन गर्नुहोस्",
      "openEvent": "घटना खोल्नुहोस्",
      "cancelEvent": "घटना रद्द गर्नुहोस्",
      "closeEarly": "चाँडै बन्द गर्नुहोस्",
      "updateEvent": "घटना अद्यावधिक गर्नुहोस्",
      "updateTags": "ट्यागहरू अद्यावधिक गर्नुहोस्",
      "escalateAndCreateNewEvent": "उच्च तहमा पठाई नयाँ घटना सिर्जना गर्नुहोस्",
      "exportEvent": "घटना निर्यात गर्नुहोस्",
      "changeOwner": "जिम्मेवार व्यक्ति परिवर्तन गर्नुहोस्",
      "changeDueDate": "अन्तिम मिति परिवर्तन गर्नुहोस्",
      "updateEventProperties": "घटनाका गुणहरू अद्यावधिक गर्नुहोस्",
      "exportListAsXLSX": "सूची XLSX का रूपमा निर्यात गर्नुहोस्",
      "exportListAsPDF": "सूची PDF का रूपमा निर्यात गर्नुहोस्",
      "approveStep": "चरण स्वीकृत गर्नुहोस्",
      "declineStep": "चरण अस्वीकार गर्नुहोस्",
      "reopenEvent": "घटना पुनः खोल्नुहोस्",
      "closeEvent": "घटना बन्द गर्नुहोस्"
    },
    "statuses": {
      "open": "खुला",
      "closed": "बन्द",
      "imported": "आयात गरिएको",
      "rejected": "अस्वीकृत",
      "canceled": "रद्द गरिएको"
    },
    "messages": {
      "eventMissingMessage": "घटना भेटिएन",
      "eventAcceptedMessage": "तपाईंले यो घटना स्वीकार गर्नुभयो",
      "eventRejectedMessage": "तपाईंले यो घटना अस्वीकार गर्नुभयो",
      "eventCanceledMessage": "तपाईंले यो घटना रद्द गर्नुभयो",
      "defaultOwnerNoPermissionTitle": "पूर्वनिर्धारित जिम्मेवार व्यक्तिसँग अनुमति छैन",
      "defaultOwnerNoPermissionMessage": "पूर्वनिर्धारित जिम्मेवार व्यक्तिसँग आवश्यक अनुमति छैन",
      "defaultAssigneeNoPermissionTitle": "पूर्वनिर्धारित तोकिएको व्यक्तिसँग अनुमति छैन",
      "defaultAssigneeNoPermissionMessage": "पूर्वनिर्धारित तोकिएको व्यक्तिसँग आवश्यक अनुमति छैन",
      "eventPropertiesNotUpdatedError": "घटनाका गुणहरू अद्यावधिक गरिएनन्",
      "missingRequiredFields": "आवश्यक फिल्डहरू छुटेका छन्",
      "temporarilyUnableToRetrieveAllEventProperties": "अस्थायी रूपमा घटनाका सबै गुणहरू प्राप्त गर्न सकिएन",
      "theTeamHasBeenNotifiedPleaseRefreshOrTryAgainLater": "टोलीलाई जानकारी दिइएको छ। कृपया रिफ्रेस गर्नुहोस् वा पछि फेरि प्रयास गर्नुहोस्।",
      "theFollowingEventFieldsWillBeCopiedToTheNewEvent": "निम्न घटना फिल्डहरू नयाँ घटनामा प्रतिलिपि गरिनेछन्:",
      "youCanEditEventFieldsAfterCreation": "सिर्जना गरेपछि तपाईं घटना फिल्डहरू सम्पादन गर्न सक्नुहुन्छ।",
      "provideAnyInformationYouHave": "तपाईंसँग भएको कुनै पनि जानकारी प्रदान गर्नुहोस्",
      "theFollowingEventFieldsWillBeCopied": "निम्न घटना फिल्डहरू नयाँ घटनामा प्रतिलिपि गरिनेछन्:",
      "removedFromProperties": "गुणहरूबाट हटाइएको:",
      "addedToProperties": "गुणहरूमा थपिएको:",
      "requiredColon": "आवश्यक:",
      "notRequired": "आवश्यक छैन:",
      "thisActionAffectsStepApprovalStatus": "यो कारबाहीले चरणको स्वीकृति स्थितिलाई असर गर्छ",
      "manageApproverType": "{{approverType}} व्यवस्थापन गर्नुहोस्",
      "approvalDeclined": "स्वीकृति अस्वीकार गरियो",
      "manageReviewers": "समीक्षकहरू व्यवस्थापन गर्नुहोस्",
      "manageQualityApprovers": "गुणस्तर स्वीकृतकर्ताहरू व्यवस्थापन गर्नुहोस्",
      "manageOtherApprovers": "अन्य स्वीकृतकर्ताहरू व्यवस्थापन गर्नुहोस्",
      "manageApprovers": "स्वीकृतकर्ताहरू व्यवस्थापन गर्नुहोस्",
      "selectUsersForReviewerFeedback": "घटना फारममा प्रतिक्रिया र सुझावहरू दिन प्रयोगकर्ताहरू चयन गर्नुहोस्।",
      "selectUsersForQualityApproval": "घटना फारमको अन्तिम स्वीकृति र हस्ताक्षरका लागि आवश्यक प्रयोगकर्ताहरू चयन गर्नुहोस्।",
      "selectUsersForOtherApproval": "घटना फारमको अन्तिम स्वीकृति र हस्ताक्षरका लागि जिम्मेवार प्रयोगकर्ताहरू चयन गर्नुहोस्।",
      "selectUsersForApproval": "घटना फारमको अन्तिम स्वीकृति र हस्ताक्षरका लागि जिम्मेवार प्रयोगकर्ताहरू चयन गर्नुहोस्।",
      "selectProductForEvent": "यस घटनासँग सम्बन्धित उत्पादन चयन गर्नुहोस्।",
      "selectRootCauseForEvent": "यस घटनाको मूल कारण चयन गर्नुहोस्।",
      "riskCalculationDescription": "जोखिम घटनाको सम्भाव्यता र गम्भीरता फिल्डहरूका आधारमा गणना गरिन्छ। ",
      "linkSuppliersToEvent": "यस घटनासँग सम्बन्धित आपूर्तिकर्ताहरू लिङ्क गर्नुहोस्। ",
      "canceledOn": "रद्द गरिएको मिति",
      "rejectedOn": "अस्वीकार गरिएको मिति",
      "closedEarlyOn": "चाँडै बन्द गरिएको मिति",
      "cancelationReason": "रद्द गर्नुको कारण",
      "rejectionReason": "अस्वीकार गर्नुको कारण",
      "closeReason": "बन्द गर्नुको कारण",
      "missingQualityTypeApprover": "गुणस्तर प्रकारको स्वीकृतकर्ता छुटेको छ",
      "requiredFieldsMustBeCompletedBeforeApprovalAndClosure": "यो घटना स्वीकृत र बन्द गर्नुअघि निम्न फिल्डहरू पूरा गर्नुपर्छ:",
      "editEventToFillMissingRequiredFields": "छुटेका आवश्यक फिल्डहरू भर्न घटना अद्यावधिक गर्नुहोस्।",
      "removingApproversWarning": "यी स्वीकृतकर्ताहरू हटाउँदा चरण स्वीकृतिका लागि बाट स्वीकृतमा परिवर्तन हुनेछ।",
      "manageCollaborators": "सहकर्मीहरू व्यवस्थापन गर्नुहोस्",
      "selectUsersForCollaboration": "घटनाका चरणहरू पूरा गर्न वा तोक्न, साथै कार्यहरू सिर्जना र व्यवस्थापन गर्न सक्ने प्रयोगकर्ताहरू चयन गर्नुहोस्।",
      "collaboratorsAdded": "सहकर्मीहरू थपिए",
      "collaboratorsRemoved": "सहकर्मीहरू हटाइए"
    },
    "modals": {
      "eventAcceptSubText": "घटना स्वीकार गर्न आफ्नो डिजिटल हस्ताक्षर प्रविष्ट गर्नुहोस्",
      "eventCancelSubText": "यो कारबाहीले घटनाका सबै चरणहरू रद्द गर्नेछ र घटनालाई रद्द गरिएको भनी चिन्ह लगाउनेछ।",
      "eventRejectSubText": "घटना अस्वीकार गर्न आफ्नो डिजिटल हस्ताक्षर प्रविष्ट गर्नुहोस्",
      "approveStepSubText": "चरण स्वीकृत गर्न आफ्नो डिजिटल हस्ताक्षर प्रविष्ट गर्नुहोस्",
      "declineStepSubText": "चरण अस्वीकार गर्न आफ्नो डिजिटल हस्ताक्षर प्रविष्ट गर्नुहोस्",
      "closeEarlySubText": "यो कारबाहीले घटनाका सबै चरणहरू रद्द गर्नेछ र घटनालाई बन्द गरिएको भनी चिन्ह लगाउनेछ।",
      "reopenEventSubText": "के तपाईं यो समस्या पुनः खोल्न निश्चित हुनुहुन्छ?",
      "eventSuccessfullyClosed": "घटना {{eventCode}} सफलतापूर्वक बन्द गरियो",
      "eventSuccessfullyReopened": "घटना {{eventCode}} सफलतापूर्वक पुनः खोलियो",
      "changeDueDateReasonPlaceholder": "अन्तिम मिति परिवर्तन गर्नुको कारण थप्नुहोस्...",
      "dueDateSuccessfullyUpdated": "अन्तिम मिति सफलतापूर्वक अद्यावधिक गरियो",
      "collaboratorsSuccessfullyUpdated": "सहकर्मीहरू सफलतापूर्वक अद्यावधिक गरिए"
    },
    "create": {
      "provideRequiredInformationToCreateAnEvent": "घटना सिर्जना गर्न आवश्यक जानकारी प्रदान गर्नुहोस्। तपाईं पछि विवरणहरू थप्न सक्नुहुन्छ।"
    },
    "tabs": {
      "details": "विवरण"
    }
  },
  "tasks": {
    "labels": {
      "taskStatus": "कार्यको स्थिति",
      "assignTo": "यसलाई तोक्नुहोस्",
      "reassignTo": "यसलाई पुनः तोक्नुहोस्"
    },
    "actions": {
      "createTask": "कार्य सिर्जना गर्नुहोस्",
      "completeTask": "कार्य पूरा गर्नुहोस्",
      "reopenTask": "कार्य पुनः खोल्नुहोस्",
      "completeStep": "चरण पूरा गर्नुहोस्",
      "actionStep": "कारबाही चरण",
      "revertStep": "चरण फिर्ता गर्नुहोस्",
      "revertStepCompletion": "चरणको पूर्णता फिर्ता गर्ने?",
      "assignStep": "चरण तोक्नुहोस्",
      "reassign": "पुनः तोक्नुहोस्",
      "assign": "तोक्नुहोस्",
      "comment": "टिप्पणी"
    },
    "modals": {
      "signOffToRevertCompletion": "\"{{stepLabel}}\" चरणको पूर्णता फिर्ता गर्न हस्ताक्षर गर्नुहोस्",
      "stepCompletionWasReverted": "\"{{stepLabel}}\" चरणको पूर्णता फिर्ता गरियो",
      "signOffToCompleteStep": "\"{{stepLabel}}\" चरण पूरा गर्न हस्ताक्षर गर्नुहोस्",
      "stepWasMarkedComplete": "\"{{stepLabel}}\" चरणलाई पूरा भएको भनी चिन्ह लगाइयो"
    },
    "messages": {
      "userReassigned": "प्रयोगकर्ता पुनः तोकियो",
      "userReassignedSuccessfully": "प्रयोगकर्ता सफलतापूर्वक पुनः तोकियो।",
      "completeFormAndSendForReview": "फारम पूरा गर्नुहोस् र तयार भएपछि समीक्षा र स्वीकृतिका लागि पठाउनुहोस्।",
      "noFormAssociatedWithStep": "यो चरणसँग कुनै फारम सम्बन्धित छैन।",
      "thisFieldRequiredBeforeClosing": "घटना बन्द गर्नुअघि यो फिल्ड आवश्यक छ।",
      "cannotSendForApprovalUntil": "यो समाधान निम्न मितिसम्म स्वीकृतिका लागि पठाउन सकिँदैन:",
      "createAndAssignTasks": "कार्यहरू सिर्जना गरी तोक्नुहोस् र तिनको प्रगति ट्र्याक गर्नुहोस्।",
      "noTasksAssociatedWithStep": "यो चरणसँग कुनै कार्य सम्बन्धित छैन।"
    }
  },
  "products": {
    "confirmations": {
      "deleteProductConfirmation": "के तपाईं \"{{productName}}\" मेटाउन निश्चित हुनुहुन्छ?"
    }
  },
  "rootCauses": {
    "labels": {
      "rootCauses": "मूल कारणहरू"
    },
    "confirmations": {
      "deleteRootCauseConfirmation": "के तपाईं \"{{rootCauseName}}\" मूल कारण मेटाउन निश्चित हुनुहुन्छ?"
    }
  },
  "search": {
    "errors": {
      "searchFailed": "खोज नतिजाहरू ल्याउन सकिएन"
    }
  }
}
